<template>
  <div class="row d-flex flex-column align-items-center justify-content-center">
    <div class="mb-2 text-center d-flex flex-column" style="font-size: 13px">
      <span class="f-bold mb-1 s-16">
        Our system uses Two-factor<br>Authentication for security.
      </span>
      <span class="f-normal">
        Please select the mobile number for your SMS security code to be sent.
      </span>
    </div>
    <div class="d-flex flex-column mt-3 mb-4">
      <div v-for="(mobilePhone, index) in SendCodeRequestServiceI.mobilePhones" :key="index">
        <input type="radio"
               :id="mobilePhone.contact_communication_info_id"
               name="mobilePhone"
               v-model="SendCodeRequestServiceI.selected"
               :value="mobilePhone">
        <label :for="mobilePhone.contact_communication_info_id" class="ml-3 f-bold c-232b2b">{{ mobilePhone.phone }}</label><br>
      </div>
    </div>
    <div class="btn ls-btn-secondary s-12 px-4" style="width: 120px" @click="$emit('selected')">
      Select
    </div>
  </div>
</template>

<script>
import ActivityService from '@/modules/common/services/activity.service';

export default {
  name: 'SelectCommunicationModal',
  props: {
    SendCodeRequestServiceI: {
      required: true,
    },
  },
  created() {
    setTimeout(() => new ActivityService().record(this.$route.params.document_unique_key, 167), 0);
  },
};
</script>
